import { getYear, addYears, addMonths, addDays, isPast} from 'utils/date-fns-compat';

import fp from 'lodash/fp';
import * as dateFns from 'date-fns';
import { branchFuncs, differenceInCalendarDays, differenceInCalendarWeeks, setYear, stubNull } from '../utils';

export const cpdDate = branchFuncs(
  fp.identity,
  branchFuncs(isPast, addYears(1), fp.identity),
  fp.identity
);

export const industryCpdDate = (state) => { 
  const { cpdDay, cpdMonth } = state;

  const currentCpdDate = dateFns.setMonth(new Date().setHours(23, 59, 59, 0), cpdMonth - 1).setDate(cpdDay);

  if (isPast(currentCpdDate)) {
    return dateFns.addYears(currentCpdDate, 1);
  }

  return currentCpdDate;
};

export const cpdYear = fp.flow(
  fp.flow(
    getYear,
    setYear
  )(new Date()),
  cpdDate,
  getYear
);

const getDefaultCpdDate = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const defaultCpdDate = new Date(currentYear, 5, 31);
  const defaultCpdDatePassed = currentDate.getTime() > defaultCpdDate.getTime();
  if (defaultCpdDatePassed) {
    return addYears(defaultCpdDate, 1);
  } else {
    return defaultCpdDate;
  }
}

export const cpdDaysRemaining = branchFuncs(
  fp.identity,
  differenceInCalendarDays(new Date()),
  () => differenceInCalendarDays(new Date())(getDefaultCpdDate()),
);

// weekStartsOn: 1 === Monday
export const cpdWeeksRemaining = branchFuncs(
  fp.identity,
  differenceInCalendarWeeks(new Date())({ weekStartsOn: 1 }),
  stubNull
);

export const startOfThisCpdPeriod = (userCpdDaysRemaining, months = 12) => {
  const today = new Date();

  return addMonths(addDays(today, userCpdDaysRemaining + 1), -1 * months);
}

export const startOfNextCpdPeriod = (userCpdDaysRemaining) => {
  const today = new Date();

  return addDays(today, userCpdDaysRemaining);
}

export const encodeNotes = (notes) => (
  notes.replace(/(?:\r\n|\r|\n)/g, '<br>')
);

export const decodeNotes = (notes) => (
  notes.replace(/\n/g, '').replace(/<br>/g, '\n')
);


// WEBPACK FOOTER //
// ./src/services/cpd-settings.js